import { database, firebase } from "../firebase";
import { v4 as uuid } from "uuid";

const getUserId = () => {
  const currentUser = firebase.auth().currentUser;
  if (!currentUser) return undefined;
  return currentUser.uid;
};

const LESSON_CARTA = {
  save: (lessonId, { text = "" }) =>
    new Promise((resolve, reject) => {
      const userId = getUserId();
      if (!userId) {
        reject("No has iniciado sesión.");
        return;
      }

      const ref = database.ref(`attempts/${userId}/${lessonId}`);

      ref.transaction(
        (current) => {
          if (current) current.text = text;
          else
            current = {
              text: text,
            };
          return current;
        },
        (error, committed) => {
          error || !committed ? reject("Ocurrió un error.") : resolve();
        }
      );
    }),
  sendAttempt: (lessonId, { text = "", courseId, episodeId, chapterId }) =>
    new Promise((resolve, reject) => {
      const userId = getUserId();
      if (!userId) {
        reject("No has iniciado sesión.");
        return;
      }

      const ref = database.ref(`attempts/${userId}/${lessonId}`);

      ref.transaction(
        (current) => {
          current = {
            attempt: current?.attempt !== undefined ? ++current.attempt : 1,
            state: "IN_REVIEW",
            text: text,
            courseId,
            episodeId,
            chapterId,
          };
          return current;
        },
        (error, committed) => {
          error || !committed ? reject("Ocurrió un error.") : resolve();
        }
      );
    }),
  evaluate: (lessonId, userId, { observations, text }) =>
    new Promise((resolve, reject) => {
      const ref = database.ref(`attempts/${userId}/${lessonId}`);

      ref.transaction(
        (current) => {
          if (current) {
            current.observations = observations;
            current.text = text;
            current.state = "FAILURE";
          }
          return current;
        },
        (error, committed) => {
          error || !committed ? reject("Ocurrió un error.") : resolve();
        }
      );
    }),
  success: (lessonId, userId) =>
    new Promise((resolve, reject) => {
      const ref = database.ref(`attempts/${userId}/${lessonId}`);

      ref.transaction(
        (current) => {
          if (current) {
            current.state = "SUCCESS";
          }
          return current;
        },
        (error, committed) => {
          error || !committed ? reject("Ocurrió un error.") : resolve();
        }
      );
    }),
  notify: (userId, { courseId, episodeId, chapterId, lessonId }) =>
    new Promise((resolve, reject) => {
      let newKey = database.ref(`notifications/${userId}`).push().key;

      let updates = {};
      updates[`notifications/${userId}/${newKey}/type`] = "REVIEW";
      updates[`notifications/${userId}/${newKey}/courseId`] = courseId;
      updates[`notifications/${userId}/${newKey}/episodeId`] = episodeId;
      updates[`notifications/${userId}/${newKey}/chapterId`] = chapterId;
      updates[`notifications/${userId}/${newKey}/lessonId`] = lessonId;
      updates[`notifications/${userId}/${newKey}/state`] = "PENDING";

      firebase
        .database()
        .ref()
        .update(updates)
        .then(() => resolve())
        .catch(() => reject("Ocurrió un error"));
    }),
};

export default { LESSON_CARTA };
